import { render, staticRenderFns } from "./ceshil.vue?vue&type=template&id=12d286ae&scoped=true&"
import script from "./ceshil.vue?vue&type=script&lang=js&"
export * from "./ceshil.vue?vue&type=script&lang=js&"
import style0 from "./ceshil.vue?vue&type=style&index=0&id=12d286ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d286ae",
  null
  
)

export default component.exports